module.exports = __webpack_public_path__ + "static/media/success-reset.687515dd.svg";